import React, { useState } from 'react';
import { LineChart, Line, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
export const FamilyBookingTrendView = () => {
  const [timeRange, setTimeRange] = useState('month');
  // Sample data for family booking trends by room type
  const familyBookingData = [{
    date: '08/25',
    standard: 3,
    deluxe: 2,
    suite: 1,
    oceanView: 0,
    total: 6
  }, {
    date: '08/26',
    standard: 2,
    deluxe: 3,
    suite: 0,
    oceanView: 1,
    total: 6
  }, {
    date: '08/27',
    standard: 4,
    deluxe: 1,
    suite: 2,
    oceanView: 0,
    total: 7
  }, {
    date: '08/28',
    standard: 3,
    deluxe: 2,
    suite: 1,
    oceanView: 2,
    total: 8
  }, {
    date: '08/29',
    standard: 2,
    deluxe: 1,
    suite: 0,
    oceanView: 1,
    total: 4
  }, {
    date: '08/30',
    standard: 5,
    deluxe: 3,
    suite: 2,
    oceanView: 1,
    total: 11
  }, {
    date: '08/31',
    standard: 4,
    deluxe: 2,
    suite: 1,
    oceanView: 0,
    total: 7
  }, {
    date: '09/01',
    standard: 3,
    deluxe: 4,
    suite: 2,
    oceanView: 1,
    total: 10
  }, {
    date: '09/02',
    standard: 2,
    deluxe: 3,
    suite: 1,
    oceanView: 0,
    total: 6
  }, {
    date: '09/03',
    standard: 1,
    deluxe: 2,
    suite: 0,
    oceanView: 1,
    total: 4
  }, {
    date: '09/04',
    standard: 3,
    deluxe: 2,
    suite: 1,
    oceanView: 0,
    total: 6
  }, {
    date: '09/05',
    standard: 4,
    deluxe: 3,
    suite: 2,
    oceanView: 1,
    total: 10
  }, {
    date: '09/06',
    standard: 5,
    deluxe: 2,
    suite: 1,
    oceanView: 0,
    total: 8
  }, {
    date: '09/07',
    standard: 3,
    deluxe: 3,
    suite: 2,
    oceanView: 1,
    total: 9
  }, {
    date: '09/08',
    standard: 4,
    deluxe: 2,
    suite: 1,
    oceanView: 0,
    total: 7
  }, {
    date: '09/09',
    standard: 2,
    deluxe: 1,
    suite: 1,
    oceanView: 1,
    total: 5
  }, {
    date: '09/10',
    standard: 3,
    deluxe: 2,
    suite: 0,
    oceanView: 0,
    total: 5
  }, {
    date: '09/11',
    standard: 4,
    deluxe: 3,
    suite: 1,
    oceanView: 1,
    total: 9
  }, {
    date: '09/12',
    standard: 5,
    deluxe: 2,
    suite: 2,
    oceanView: 0,
    total: 9
  }, {
    date: '09/13',
    standard: 3,
    deluxe: 4,
    suite: 1,
    oceanView: 1,
    total: 9
  }, {
    date: '09/14',
    standard: 4,
    deluxe: 3,
    suite: 0,
    oceanView: 0,
    total: 7
  }, {
    date: '09/15',
    standard: 2,
    deluxe: 2,
    suite: 1,
    oceanView: 1,
    total: 6
  }, {
    date: '09/16',
    standard: 3,
    deluxe: 1,
    suite: 2,
    oceanView: 0,
    total: 6
  }, {
    date: '09/17',
    standard: 4,
    deluxe: 3,
    suite: 1,
    oceanView: 1,
    total: 9
  }, {
    date: '09/18',
    standard: 5,
    deluxe: 2,
    suite: 0,
    oceanView: 0,
    total: 7
  }, {
    date: '09/19',
    standard: 3,
    deluxe: 3,
    suite: 1,
    oceanView: 1,
    total: 8
  }, {
    date: '09/20',
    standard: 4,
    deluxe: 2,
    suite: 2,
    oceanView: 0,
    total: 8
  }, {
    date: '09/21',
    standard: 3,
    deluxe: 1,
    suite: 1,
    oceanView: 1,
    total: 6
  }, {
    date: '09/22',
    standard: 4,
    deluxe: 3,
    suite: 1,
    oceanView: 0,
    total: 8
  }];
  // Calculate total bookings by room type
  const totalBookingsByType = familyBookingData.reduce((acc, curr) => {
    acc.standard += curr.standard;
    acc.deluxe += curr.deluxe;
    acc.suite += curr.suite;
    acc.oceanView += curr.oceanView;
    acc.total += curr.total;
    return acc;
  }, {
    standard: 0,
    deluxe: 0,
    suite: 0,
    oceanView: 0,
    total: 0
  });
  // Data for the room type distribution pie chart
  const roomTypeDistribution = [{
    name: 'Standard',
    value: totalBookingsByType.standard,
    percentage: Math.round(totalBookingsByType.standard / totalBookingsByType.total * 100)
  }, {
    name: 'Deluxe',
    value: totalBookingsByType.deluxe,
    percentage: Math.round(totalBookingsByType.deluxe / totalBookingsByType.total * 100)
  }, {
    name: 'Suite',
    value: totalBookingsByType.suite,
    percentage: Math.round(totalBookingsByType.suite / totalBookingsByType.total * 100)
  }, {
    name: 'Ocean View',
    value: totalBookingsByType.oceanView,
    percentage: Math.round(totalBookingsByType.oceanView / totalBookingsByType.total * 100)
  }];
  // Weekly summary data
  const weeklySummary = [{
    week: 'Week 1 (08/25 - 08/31)',
    bookings: 49,
    avgPerDay: 7
  }, {
    week: 'Week 2 (09/01 - 09/07)',
    bookings: 53,
    avgPerDay: 7.6
  }, {
    week: 'Week 3 (09/08 - 09/14)',
    bookings: 51,
    avgPerDay: 7.3
  }, {
    week: 'Week 4 (09/15 - 09/22)',
    bookings: 58,
    avgPerDay: 8.3
  }];
  // Calculate average, min, and max
  const avgBookingsPerDay = Math.round(familyBookingData.reduce((sum, day) => sum + day.total, 0) / familyBookingData.length);
  const minBookings = Math.min(...familyBookingData.map(day => day.total));
  const maxBookings = Math.max(...familyBookingData.map(day => day.total));
  return <div className="p-6" data-id="element-111">
      <div className="mb-6 flex justify-between items-center" data-id="element-112">
        <div data-id="element-113">
          <h1 className="text-2xl font-bold text-gray-800" data-id="element-114">
            Family Booking Trend Report
          </h1>
          <p className="text-sm text-gray-600" data-id="element-115">
            Analysis of family bookings by room type over the past month
          </p>
        </div>
        <div className="flex items-center space-x-2" data-id="element-116">
          <button onClick={() => setTimeRange('week')} className={`px-3 py-1.5 text-sm font-medium rounded-md ${timeRange === 'week' ? 'bg-teal-500 text-white' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'}`} data-id="element-117">
            Week
          </button>
          <button onClick={() => setTimeRange('month')} className={`px-3 py-1.5 text-sm font-medium rounded-md ${timeRange === 'month' ? 'bg-teal-500 text-white' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'}`} data-id="element-118">
            Month
          </button>
        </div>
      </div>
      {/* Summary Cards */}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-6" data-id="element-119">
        <div className="bg-blue-50 p-4 rounded-lg border border-blue-100" data-id="element-120">
          <h3 className="text-sm font-medium text-blue-800 mb-1" data-id="element-121">
            Total Family Bookings
          </h3>
          <p className="text-2xl font-bold text-blue-700" data-id="element-122">
            {totalBookingsByType.total}
          </p>
          <p className="text-xs text-blue-600 mt-1" data-id="element-123">Past 30 days</p>
        </div>
        <div className="bg-green-50 p-4 rounded-lg border border-green-100" data-id="element-124">
          <h3 className="text-sm font-medium text-green-800 mb-1" data-id="element-125">
            Average Per Day
          </h3>
          <p className="text-2xl font-bold text-green-700" data-id="element-126">
            {avgBookingsPerDay}
          </p>
          <p className="text-xs text-green-600 mt-1" data-id="element-127">Family bookings</p>
        </div>
        <div className="bg-yellow-50 p-4 rounded-lg border border-yellow-100" data-id="element-128">
          <h3 className="text-sm font-medium text-yellow-800 mb-1" data-id="element-129">
            Minimum Bookings
          </h3>
          <p className="text-2xl font-bold text-yellow-700" data-id="element-130">{minBookings}</p>
          <p className="text-xs text-yellow-600 mt-1" data-id="element-131">Lowest daily total</p>
        </div>
        <div className="bg-purple-50 p-4 rounded-lg border border-purple-100" data-id="element-132">
          <h3 className="text-sm font-medium text-purple-800 mb-1" data-id="element-133">
            Maximum Bookings
          </h3>
          <p className="text-2xl font-bold text-purple-700" data-id="element-134">{maxBookings}</p>
          <p className="text-xs text-purple-600 mt-1" data-id="element-135">Highest daily total</p>
        </div>
      </div>
      {/* Main Chart */}
      <div className="bg-white p-4 rounded-lg border border-gray-200 mb-6" data-id="element-136">
        <h3 className="text-lg font-medium text-gray-700 mb-4" data-id="element-137">
          Daily Family Bookings by Room Type
        </h3>
        <div className="h-80" data-id="element-138">
          <ResponsiveContainer width="100%" height="100%" data-id="element-139">
            <LineChart data={familyBookingData} margin={{
            top: 5,
            right: 30,
            left: 20,
            bottom: 5
          }} data-id="element-140">
              <CartesianGrid strokeDasharray="3 3" data-id="element-141" />
              <XAxis dataKey="date" data-id="element-142" />
              <YAxis data-id="element-143" />
              <Tooltip data-id="element-144" />
              <Legend data-id="element-145" />
              <Line type="monotone" dataKey="total" stroke="#8884d8" strokeWidth={2} name="Total" data-id="element-146" />
              <Line type="monotone" dataKey="standard" stroke="#82ca9d" name="Standard" data-id="element-147" />
              <Line type="monotone" dataKey="deluxe" stroke="#ffc658" name="Deluxe" data-id="element-148" />
              <Line type="monotone" dataKey="suite" stroke="#ff8042" name="Suite" data-id="element-149" />
              <Line type="monotone" dataKey="oceanView" stroke="#0088fe" name="Ocean View" data-id="element-150" />
            </LineChart>
          </ResponsiveContainer>
        </div>
      </div>
      {/* Room Type Distribution and Weekly Summary */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-6" data-id="element-151">
        <div className="bg-white p-4 rounded-lg border border-gray-200" data-id="element-152">
          <h3 className="text-lg font-medium text-gray-700 mb-4" data-id="element-153">
            Room Type Distribution
          </h3>
          <div className="h-64" data-id="element-154">
            <ResponsiveContainer width="100%" height="100%" data-id="element-155">
              <BarChart data={roomTypeDistribution} layout="vertical" margin={{
              top: 5,
              right: 30,
              left: 20,
              bottom: 5
            }} data-id="element-156">
                <CartesianGrid strokeDasharray="3 3" data-id="element-157" />
                <XAxis type="number" data-id="element-158" />
                <YAxis type="category" dataKey="name" data-id="element-159" />
                <Tooltip formatter={value => [`${value} bookings`, 'Families']} data-id="element-160" />
                <Legend data-id="element-161" />
                <Bar dataKey="value" fill="#8884d8" name="Family Bookings" label={{
                position: 'right',
                formatter: value => `${value}`
              }} data-id="element-162" />
              </BarChart>
            </ResponsiveContainer>
          </div>
        </div>
        <div className="bg-white p-4 rounded-lg border border-gray-200" data-id="element-163">
          <h3 className="text-lg font-medium text-gray-700 mb-4" data-id="element-164">
            Weekly Summary
          </h3>
          <div className="overflow-x-auto" data-id="element-165">
            <table className="min-w-full divide-y divide-gray-200" data-id="element-166">
              <thead data-id="element-167">
                <tr data-id="element-168">
                  <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-169">
                    Week
                  </th>
                  <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-170">
                    Total Bookings
                  </th>
                  <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-171">
                    Avg. Per Day
                  </th>
                  <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-172">
                    Trend
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200" data-id="element-173">
                {weeklySummary.map((week, index) => <tr key={index} className={index % 2 === 0 ? 'bg-gray-50' : 'bg-white'} data-id="element-174">
                    <td className="px-4 py-2 whitespace-nowrap text-sm font-medium text-gray-900" data-id="element-175">
                      {week.week}
                    </td>
                    <td className="px-4 py-2 whitespace-nowrap text-sm text-gray-500" data-id="element-176">
                      {week.bookings}
                    </td>
                    <td className="px-4 py-2 whitespace-nowrap text-sm text-gray-500" data-id="element-177">
                      {week.avgPerDay}
                    </td>
                    <td className="px-4 py-2 whitespace-nowrap text-sm" data-id="element-178">
                      {index > 0 ? week.bookings > weeklySummary[index - 1].bookings ? <span className="text-green-600 flex items-center" data-id="element-179">
                            <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-1" viewBox="0 0 20 20" fill="currentColor" data-id="element-180">
                              <path fillRule="evenodd" d="M12 7a1 1 0 110-2h5a1 1 0 011 1v5a1 1 0 11-2 0V8.414l-4.293 4.293a1 1 0 01-1.414 0L8 10.414l-4.293 4.293a1 1 0 01-1.414-1.414l5-5a1 1 0 011.414 0L11 10.586 14.586 7H12z" clipRule="evenodd" data-id="element-181" />
                            </svg>
                            Up{' '}
                            {Math.round((week.bookings - weeklySummary[index - 1].bookings) / weeklySummary[index - 1].bookings * 100)}
                            %
                          </span> : week.bookings < weeklySummary[index - 1].bookings ? <span className="text-red-600 flex items-center" data-id="element-182">
                            <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-1" viewBox="0 0 20 20" fill="currentColor" data-id="element-183">
                              <path fillRule="evenodd" d="M12 13a1 1 0 100 2h5a1 1 0 001-1v-5a1 1 0 10-2 0v2.586l-4.293-4.293a1 1 0 00-1.414 0L8 9.586l-4.293-4.293a1 1 0 00-1.414 1.414l5 5a1 1 0 001.414 0L11 9.414 14.586 13H12z" clipRule="evenodd" data-id="element-184" />
                            </svg>
                            Down{' '}
                            {Math.round((weeklySummary[index - 1].bookings - week.bookings) / weeklySummary[index - 1].bookings * 100)}
                            %
                          </span> : <span className="text-gray-600" data-id="element-185">No change</span> : <span className="text-gray-600" data-id="element-186">Baseline</span>}
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      {/* Insights */}
      <div className="bg-white p-4 rounded-lg border border-gray-200" data-id="element-187">
        <h3 className="text-lg font-medium text-gray-700 mb-4" data-id="element-188">Key Insights</h3>
        <div className="space-y-4" data-id="element-189">
          <div className="flex items-start gap-3" data-id="element-190">
            <div className="bg-teal-100 p-2 rounded-full" data-id="element-191">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-teal-600" viewBox="0 0 20 20" fill="currentColor" data-id="element-192">
                <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" data-id="element-193" />
              </svg>
            </div>
            <div data-id="element-194">
              <h4 className="text-sm font-medium text-gray-800" data-id="element-195">
                Increasing Family Bookings
              </h4>
              <p className="text-sm text-gray-600" data-id="element-196">
                Family bookings have increased by 18% compared to the previous
                month, with the most significant growth in the Standard room
                category.
              </p>
            </div>
          </div>
          <div className="flex items-start gap-3" data-id="element-197">
            <div className="bg-blue-100 p-2 rounded-full" data-id="element-198">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-blue-600" viewBox="0 0 20 20" fill="currentColor" data-id="element-199">
                <path d="M2 11a1 1 0 011-1h2a1 1 0 011 1v5a1 1 0 01-1 1H3a1 1 0 01-1-1v-5zM8 7a1 1 0 011-1h2a1 1 0 011 1v9a1 1 0 01-1 1H9a1 1 0 01-1-1V7zM14 4a1 1 0 011-1h2a1 1 0 011 1v12a1 1 0 01-1 1h-2a1 1 0 01-1-1V4z" data-id="element-200" />
              </svg>
            </div>
            <div data-id="element-201">
              <h4 className="text-sm font-medium text-gray-800" data-id="element-202">
                Weekend Peak Pattern
              </h4>
              <p className="text-sm text-gray-600" data-id="element-203">
                Family bookings consistently peak on Fridays and Saturdays, with
                an average increase of 35% compared to weekday bookings.
              </p>
            </div>
          </div>
          <div className="flex items-start gap-3" data-id="element-204">
            <div className="bg-purple-100 p-2 rounded-full" data-id="element-205">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-purple-600" viewBox="0 0 20 20" fill="currentColor" data-id="element-206">
                <path fillRule="evenodd" d="M5 2a1 1 0 011 1v1h1a1 1 0 010 2H6v1a1 1 0 01-2 0V6H3a1 1 0 010-2h1V3a1 1 0 011-1zm0 10a1 1 0 011 1v1h1a1 1 0 110 2H6v1a1 1 0 11-2 0v-1H3a1 1 0 110-2h1v-1a1 1 0 011-1zM12 2a1 1 0 01.967.744L14.146 7.2 17.5 9.134a1 1 0 010 1.732l-3.354 1.935-1.18 4.455a1 1 0 01-1.933 0L9.854 12.8 6.5 10.866a1 1 0 010-1.732l3.354-1.935 1.18-4.455A1 1 0 0112 2z" clipRule="evenodd" data-id="element-207" />
              </svg>
            </div>
            <div data-id="element-208">
              <h4 className="text-sm font-medium text-gray-800" data-id="element-209">
                Room Type Preference
              </h4>
              <p className="text-sm text-gray-600" data-id="element-210">
                Standard and Deluxe rooms account for 72% of all family
                bookings, suggesting these categories are most appealing to
                family travelers.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>;
};